import React from 'react';
import { motion } from 'framer-motion';
import aboutimage1 from "../assets/images/aboutimage1.avif";
import aboutPic from '../../src/assets/images/Frame 427 3.png';
import nirmal from '../../src/assets/about_images/nirmal.png';
import stebin from '../../src/assets/about_images/stebin.jpeg';
import jeffrin from '../../src/assets/about_images/jeffrin.jpeg';
import { useNavigate } from "react-router-dom";
import { pythonIcon, nextIcon, nodeIcon, awsIcon, firebaseIcon, mongodbIcon, tensorflowIcon, flutterIcon } from '../components/svg/about';

const About = () => {
  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: "beforeChildren"
      }
    }
  };
 const navigate = useNavigate();
  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10
      }
    }
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.8 }
    }
  };

  const cardHover = {
    scale: 1.03,
    transition: { duration: 0.3 }
  };

  const heroVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const textVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { delay: 0.4, duration: 0.8 }
    }
  };

  // New animations
  const floatAnimation = {
    y: [0, -10, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  const pulseAnimation = {
    scale: [1, 1.05, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 10
    }
  }
};

// for testing 
  return (
    <div className="">
      {/* 4K Hero Image Section */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={heroVariants}
        className="relative w-full h-screen max-h-[80vh] overflow-hidden"
      >
        <img
          src={aboutimage1}
          alt="Our Team"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40 flex items-center justify-center">
          <motion.h1
            variants={textVariants}
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-white text-center px-4"
          >
            Meet Our Team
          </motion.h1>
          <motion.div
            animate={floatAnimation}
            className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </motion.div>
        </div>
      </motion.div>

      {/* About Content */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={container}
        className="text-gray-800 px-4 py-10 lg:px-20 relative"
      >
        {/* Intro */}
        <motion.section
          variants={fadeIn}
          className="text-center mb-16 relative"
        >
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-amber-500 rounded-full"></div>
          <motion.h1
            variants={item}
            className="text-4xl font-bold mb-6 relative inline-block"
          >
            About Us
            <motion.div
              className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-amber-500"
              initial={{ width: 0 }}
              animate={{ width: 64 }}
              transition={{ delay: 0.5, duration: 0.5 }}
            ></motion.div>
          </motion.h1>
          <motion.p
            variants={item}
            className="max-w-2xl mx-auto text-lg text-gray-600"
          >
            We are a passionate team dedicated to delivering creative and effective digital solutions. Here's a bit about who we are and what we do.
          </motion.p>
        </motion.section>

        {/* Team Cards */}
        <motion.section
  variants={container}
  className="grid md:grid-cols-3 gap-6 md:gap-4 lg:gap-8 mb-20"
>
  {/* Stebin Card */}
  <motion.div
    variants={item}
    whileHover={cardHover}
    className="bg-white rounded-2xl shadow-lg p-6 text-center border border-amber-100 relative overflow-hidden"
  >
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-amber-600"></div>
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.2, type: "spring" }}
      className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 mx-auto rounded-full mb-4 relative overflow-hidden border-4 border-amber-100"
    >
      <div className="absolute inset-0 from-amber-400/20 to-amber-600/20">
        <img
          src={stebin}
          alt="Stebin"
          className="w-full h-full object-cover object-center"
        />
      </div>
    </motion.div>
    <h2 className="text-lg md:text-xl font-semibold mb-2">Stebin Milton</h2>
    <p className="text-amber-600 font-medium text-sm md:text-base">Frontend Developer & Project Lead</p>
    <p className="mt-4 text-xs md:text-sm text-gray-500 md:leading-relaxed">
      Passionate Frontend Developer specializing in building intuitive, high-performance web interfaces with React.js and Tailwind CSS, with a strong focus on modern UI/UX design.
    </p>
    <motion.div
      className="flex justify-center mt-4 space-x-2 md:space-x-3 flex-wrap gap-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6 }}
    >
      {['React', 'Tailwind', 'Node.js'].map((tech, index) => (
        <span key={index} className="px-2 md:px-3 py-1 bg-amber-100 text-amber-700 text-xs rounded-full whitespace-nowrap">
          {tech}
        </span>
      ))}
    </motion.div>
    {/* Contact Information */}
    <div className="mt-4 space-y-2">
      <div className="flex items-center justify-center text-xs md:text-sm text-gray-600">
        <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 text-amber-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
        <a href="mailto:stebinmilton@gmail.com" className="hover:text-amber-600 transition-colors break-all md:break-normal">
          stebinmilton@gmail.com
        </a>
      </div>
    </div>

    {/* Social Links */}
    <div className="mt-4 space-y-2">
      <div className="flex justify-center space-x-3 md:space-x-4 flex-wrap gap-2">
        <a
          href="https://www.linkedin.com/in/stebin-milton/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-blue-600 hover:text-blue-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.299v15.402C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.299C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
          </svg>
          LinkedIn
        </a>
        <a
          href="https://stebinmilton.github.io/portfolio/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-purple-600 hover:text-purple-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
          Portfolio
        </a>
        <a
          href="https://github.com/stebinmilton"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-gray-700 hover:text-gray-900 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
          </svg>
          GitHub
        </a>
      </div>
    </div>
  </motion.div>

  {/* Nirmal Card */}
  <motion.div
    variants={item}
    whileHover={cardHover}
    className="bg-white rounded-2xl shadow-lg p-6 text-center border border-amber-100 relative overflow-hidden"
  >
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-amber-600"></div>
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.3, type: "spring" }}
      className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 mx-auto rounded-full mb-4 relative overflow-hidden border-4 border-amber-100"
    >
      <div className="absolute inset-0  from-amber-400/20 to-amber-600/20"></div>
      <img
        src={nirmal}
        alt="Nirmal"
        className="w-full h-full object-cover object-center"
      />
    </motion.div>
    <h2 className="text-lg md:text-xl font-semibold mb-2">Chandra Nirmal</h2>
    <p className="text-amber-600 font-medium text-sm md:text-base">Web & Mobile App Developer</p>
    <p className="mt-4 text-xs md:text-sm text-gray-500 md:leading-relaxed">
      Experienced Backend Developer with a strong focus on designing and implementing scalable, high-performance applications, emphasizing system architecture, reliability, and maintainability.
    </p>
    <motion.div
      className="flex justify-center mt-4 space-x-2 md:space-x-3 flex-wrap gap-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
    >
      {['MERN', 'React Native', 'System Design'].map((tech, index) => (
        <span key={index} className="px-2 md:px-3 py-1 bg-amber-100 text-amber-700 text-xs rounded-full whitespace-nowrap">
          {tech}
        </span>
      ))}
    </motion.div>

    {/* Contact Information */}
    <div className="mt-4 space-y-2">
      <div className="flex items-center justify-center text-xs md:text-sm text-gray-600">
        <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 text-amber-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
        <a href="mailto:chandranirmal002@gmail.com" className="hover:text-amber-600 transition-colors break-all md:break-normal">
          chandranirmal002@gmail.com
        </a>
      </div>
    </div>

    {/* Social Links */}
    <div className="mt-4 space-y-2">
      <div className="flex justify-center space-x-3 md:space-x-4 flex-wrap gap-2">
        <a
          href="https://www.linkedin.com/in/chandra-nirmal-940430231/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-blue-600 hover:text-blue-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.299v15.402C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.299C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
          </svg>
          LinkedIn
        </a>
        <a
          href="https://portfolio-n1gohcaec-chandra-nirmals-projects.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-purple-600 hover:text-purple-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
          Portfolio
        </a>
        <a
          href="https://github.com/Nirmal-cool"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-gray-700 hover:text-gray-900 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
          </svg>
          GitHub
        </a>
      </div>
    </div>
  </motion.div>

  {/* Jeffrin Card */}
  <motion.div
    variants={item}
    whileHover={cardHover}
    className="bg-white rounded-2xl shadow-lg p-6 text-center border border-amber-100 relative overflow-hidden"
  >
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-amber-600"></div>
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.4, type: "spring" }}
      className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 mx-auto bg-gray-300 rounded-full mb-4 relative overflow-hidden border-4 border-amber-100"
    >
      <img
        src={jeffrin}
        alt="Jeffrin"
        className="w-full h-full object-cover object-center"
      />
    </motion.div>
    <h2 className="text-lg md:text-xl font-semibold mb-2">Jeffrin</h2>
    <p className="text-amber-600 font-medium text-sm md:text-base">Python Developer</p>
    <p className="mt-4 text-xs md:text-sm text-gray-500 md:leading-relaxed">
      Responsible for designing and implementing robust server-side logic, ensuring our systems operate securely, efficiently, and reliably while supporting scalable and high-performance applications.
    </p>
    <motion.div
      className="flex justify-center mt-4 space-x-2 md:space-x-3 flex-wrap gap-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8 }}
    >
      {['Python', 'Django', 'PostgreSQL'].map((tech, index) => (
        <span key={index} className="px-2 md:px-3 py-1 bg-amber-100 text-amber-700 text-xs rounded-full whitespace-nowrap">
          {tech}
        </span>
      ))}
    </motion.div>

    {/* Contact Information */}
    <div className="mt-4 space-y-2">
      <div className="flex items-center justify-center text-xs md:text-sm text-gray-600">
        <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 text-amber-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
        <a href="mailto:jef1619@gmail.com" className="hover:text-amber-600 transition-colors break-all md:break-normal">
          jef1619@gmail.com
        </a>
      </div>
    </div>

    {/* Social Links */}
    <div className="mt-4 space-y-2">
      <div className="flex justify-center space-x-3 md:space-x-4 flex-wrap gap-2">
        <a
          href="https://www.linkedin.com/in/jeffrin-g-91a937288/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-blue-600 hover:text-blue-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.299v15.402C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.299C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
          </svg>
          LinkedIn
        </a>
        <a
          href=" https://jeffrinsportfolio.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-purple-600 hover:text-purple-700 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
          Portfolio
        </a>
        <a
          href="https://github.com/Jeff1619"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs md:text-sm text-gray-700 hover:text-gray-900 transition-colors"
        >
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
          </svg>
          GitHub
        </a>
      </div>
    </div>
  </motion.div>
</motion.section>

        {/* Services Summary Section */}
        <motion.section
          variants={container}
          className="mb-20"
        >
          <motion.h2
            variants={item}
            className="text-3xl font-semibold text-center mb-10 relative"
          >
            What We Offer
            <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-amber-500 rounded-full"></div>
          </motion.h2>
          <motion.div
            variants={container}
            className="grid md:grid-cols-3 gap-8"
          >
            <motion.div
              variants={item}
              whileHover={cardHover}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition border border-amber-100 relative overflow-hidden group"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 group-hover:h-2 transition-all duration-300"></div>
              <motion.div
                animate={pulseAnimation}
                className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-4"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
              </motion.div>
              <h3 className="text-xl font-bold mb-3">Website Development</h3>
              <p className="text-gray-600">
                We create responsive and fast websites tailored to client needs.
              </p>
            </motion.div>
            <motion.div
              variants={item}
              whileHover={cardHover}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition border border-amber-100 relative overflow-hidden group"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 group-hover:h-2 transition-all duration-300"></div>
              <motion.div
                animate={pulseAnimation}
                className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-4"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
                </svg>
              </motion.div>
              <h3 className="text-xl font-bold mb-3">UI/UX Design</h3>
              <p className="text-gray-600">
                From wireframes to final design, we ensure your product looks and feels great.
              </p>
            </motion.div>
            <motion.div
              variants={item}
              whileHover={cardHover}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition border border-amber-100 relative overflow-hidden group"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 group-hover:h-2 transition-all duration-300"></div>
              <motion.div
                animate={pulseAnimation}
                className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-4"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </motion.div>
              <h3 className="text-xl font-bold mb-3">Performance Optimization</h3>
              <p className="text-gray-600">
                We improve speed, SEO, and accessibility to maximize your digital impact.
              </p>
            </motion.div>
          </motion.div>
        </motion.section>
          {/* Technology Stack */}
                <motion.section
                  initial="hidden"
                  whileInView="visible"
                  variants={containerVariants}
                  viewport={{ once: true, margin: "-100px" }}
                  className="mb-20"
                >
                  <div className="text-center max-w-3xl mx-auto mb-12">
                    <motion.h2
                      variants={itemVariants}
                      className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
                    >
                      Built With Modern <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text text-transparent">Technologies</span>
                    </motion.h2>
                    <motion.p
                      variants={itemVariants}
                      className="text-gray-600 text-xl"
                    >
                      We leverage cutting-edge tools and frameworks to deliver high-performance, scalable solutions.
                    </motion.p>
                  </div>
        
                  <motion.div
                    variants={containerVariants}
                    className="grid grid-cols-2 md:grid-cols-4 gap-5"
                  >
                    {[
                      { name: "React/Next.js", icon: nextIcon },
                      { name: "Node.js", icon: nodeIcon },
                      { name: "Python", icon: pythonIcon },
                      { name: "AWS", icon: awsIcon },
                      { name: "Firebase", icon: firebaseIcon },
                      { name: "MongoDB", icon: mongodbIcon },
                      { name: "TensorFlow", icon: tensorflowIcon },
                      { name: "Flutter", icon: flutterIcon }
                    ].map((tech, index) => (
                      <motion.div
                        key={index}
                        variants={itemVariants}
                        whileHover={{ scale: 1.05, y: -5 }}
                        className="bg-white p-5 rounded-2xl shadow-md border border-gray-100 text-center"
                      >
                        <div className="text-2xl mb-3 flex justify-center items-center">{tech.icon}</div>
                        <h3 className="font-semibold text-gray-900 text-sm">{tech.name}</h3>
                      </motion.div>
                    ))}
                  </motion.div>
                </motion.section>

        {/* Stats Section */}
        <motion.section
          initial="hidden"
          whileInView="visible"
          variants={container}
          viewport={{ once: true }}
          className="mb-20 bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 text-white shadow-lg"
        >
          <motion.h2
            variants={item}
            className="text-3xl font-semibold text-center mb-10"
          >
            Our Impact in Numbers
          </motion.h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { number: '10+', label: 'Projects Completed' },
              { number: '10+', label: 'Happy Clients' },
              { number: '02+', label: 'Years Experience' },
              { number: '98%', label: 'Client Satisfaction' }
            ].map((stat, index) => (
              <motion.div
                key={index}
                variants={item}
                className="text-center p-4 bg-white/10 rounded-xl backdrop-blur-sm"
              >
                <motion.p
                  className="text-4xl font-bold mb-2"
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ delay: index * 0.1, type: "spring" }}
                >
                  {stat.number}
                </motion.p>
                <p className="text-amber-100">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Closing Section */}
        <motion.section
          variants={fadeIn}
          className="text-center mb-16"
        >
          <motion.p
            variants={item}
            className="text-gray-700 text-lg max-w-xl mx-auto mb-10"
          >
            We believe in building long-term relationships with our clients through quality, honesty, and creativity.
          </motion.p>

      <div className='md:flex-row bg-gradient-to-br from-gray-900 to-black text-white rounded-3xl overflow-hidden shadow-2xl md:gap-8 flex flex-col gap-5 px-5 lg:px-20 py-10 md:py-14'>
  <div className='md:w-1/2 md:justify-between flex flex-col gap-5'>
    <motion.div
      initial={{ y: "-6vw", opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ type: "tween", stiffness: 120, duration: 0.8 }}
      className='flex items-center gap-4'
    >
      <span className='border border-amber-400 w-16'></span>
      <h1 className='font-semibold text-amber-400'>About Us</h1>
    </motion.div>

    <motion.p
      initial={{ y: "-6vw", opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.1 }}
      className='text-xl md:text-3xl md:w-2/3 leading-tight font-semibold capitalize'
    >
      Shaping ideas, <span className='text-amber-400'>building digital futures</span>
    </motion.p>

    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2 }}
      className='text-sm md:text-base capitalize text-gray-300'
    >
      Geocode is a creative freelancing and training hub dedicated to delivering modern web
      solutions and empowering learners. Our mission is to craft clean, impactful designs and
      user-friendly applications while guiding students and interns through real-world coding
      experiences. With passion and innovation, we help both clients and learners achieve lasting success.
    </motion.p>

    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      className='flex flex-col gap-3'
    >
      <div className='flex items-center gap-3'>
        <div className="bg-amber-500 rounded-full p-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6 text-white">
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
          </svg>
        </div>
        <p className='text-sm md:text-base font-medium'>Affordable & Custom Web Solutions</p>
      </div>
      <div className='flex items-center gap-3'>
        <div className="bg-amber-500 rounded-full p-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6 text-white">
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
          </svg>
        </div>
        <p className='text-sm md:text-base font-medium'>Collaborative Team of Freelancers</p>
      </div>
      <div className='flex items-center gap-3'>
        <div className="bg-amber-500 rounded-full p-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6 text-white">
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
          </svg>
        </div>
        <p className='text-sm md:text-base font-medium'>Hands-On Learning With Real Projects</p>
      </div>
    </motion.div>

    <motion.div
      initial={{ x: "-5vw", opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.5, type: "spring", stiffness: 120 }}
    >
      <button
        onClick={() => navigate("/service")}
        className="md:w-max px-8 py-3 bg-amber-500 hover:bg-amber-600 text-white rounded-full flex items-center gap-2 transition-all duration-300 whitespace-nowrap"
      >
        <span>Learn More</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="size-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
          />
        </svg>
      </button>
    </motion.div>
  </div>

  <motion.div
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.7, delay: 0.5 }}
    className='md:w-1/2 relative overflow-hidden flex justify-end rounded-2xl'
  >
    <div className="w-full h-full">
      <img className='rounded-2xl object-cover object-center h-full w-full' src={aboutPic} alt='about_pic' />
    </div>
    <motion.div
      className='absolute bg-amber-500 text-white rounded-2xl px-4 py-3 bottom-4 right-4 flex items-center gap-3 border-4 border-white shadow-lg'
      initial={{ y: 20, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.8 }}
    >
      <h1 className='text-xl font-bold'>02+</h1>
      <p className='font-medium'>Years of<br />collaboration</p>
    </motion.div>
  </motion.div>
</div>

        </motion.section>

         {/* Testimonials Section */}
        <motion.section
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={{ once: true, margin: "-100px" }}
          className="mb-20"
        >
          <div className="text-center max-w-3xl mx-auto mb-12">
            <motion.span
              variants={itemVariants}
              className="inline-block px-4 py-1.5 bg-yellow-100 text-yellow-700 rounded-full text-sm font-medium mb-4"
            >
              Testimonials
            </motion.span>
            <motion.h2
              variants={itemVariants}
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            >
              What Our <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text text-transparent">Clients Say</span>
            </motion.h2>
          </div>

          <motion.div
            variants={containerVariants}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {[
              {
                name: "Sarah Johnson",
                role: "CEO, TechInnovate",
                content: "The team delivered beyond our expectations. Our website traffic increased by 150% after the redesign, and the user experience is now seamless.",
                avatar: "SJ"
              },
              {
                name: "Michael Chen",
                role: "Marketing Director, GrowthLabs",
                content: "Their strategic approach to our digital transformation was impressive. They understood our vision and executed it perfectly.",
                avatar: "MC"
              },
              {
                name: "Emma Rodriguez",
                role: "Founder, NovaSolutions",
                content: "Working with this team was a game-changer for our business. They're responsive, professional, and truly care about our success.",
                avatar: "ER"
              }
            ].map((testimonial, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={cardHover}
                className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100"
              >
                <div className="flex items-center mb-5">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-700 font-bold mr-3 text-md">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-gray-500 text-sm">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-600 mb-5 text-sm">
                  "{testimonial.content}"
                </p>
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.section>

        {/* CTA Section */}
        <motion.section
          initial="hidden"
          whileInView="visible"
          variants={container}
          viewport={{ once: true }}
          className="text-center py-16  bg-gradient-to-br from-gray-900 to-black rounded-3xl text-white shadow-lg"
        >
          <motion.h2 variants={item} className="text-3xl font-bold mb-6">
            Ready to Start Your Project?
          </motion.h2>
          <motion.p variants={item} className="max-w-2xl mx-auto mb-8 text-white">
            Let's collaborate to bring your ideas to life with innovative solutions tailored to your needs.
          </motion.p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={()=> navigate("/contact")}
            className="bg-white text-amber-600 px-8 py-3 rounded-full font-semibold shadow-md hover:shadow-lg transition-all duration-300"
          >
            Contact Us Today
          </motion.button>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default About;